import { Nommable } from '../nommable.model';
import { IZone } from './zone.interface';
import { Scannable } from './scannable.model';
import { IScannable } from './scannable.interface';

export class Zone extends Nommable implements IZone {
  constructor(
    id: string,
    libelle: string,
    public readonly scannableAnomalie?: IScannable
  ) {
    super(id, libelle);
  }

  public static hydrate(obj: Zone): Zone {
    return new Zone(obj.id, obj.libelle, obj.scannableAnomalie ? Scannable.hydrate(obj.scannableAnomalie) : undefined);
  }
}
